import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { IPersonalApiKey } from './useGetPersonalApiKeys';

export interface IPostPersonalApiKeyInput {
	description?: string;
	scopes: string[];
	expirationDays: number;
}

export function usePostPersonalApiKeyMutation() {
	const userSession = useUserSession();
	return useMutation({
		mutationFn: (input: IPostPersonalApiKeyInput) =>
			userSession.webServiceHelper.callAsync<IPersonalApiKey>(
				Api.ImpersonationBroker.composeApiUrl({
					urlPath: 'personalapikeys',
				}),
				'POST',
				input
			),
	});
}
